import { render, staticRenderFns } from "./ColegiadoNew.vue?vue&type=template&id=d28d0dde&scoped=true&"
import script from "./ColegiadoNew.vue?vue&type=script&lang=js&"
export * from "./ColegiadoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28d0dde",
  null
  
)

export default component.exports